import {GetterTree} from 'vuex'
import IUser from "@/modules/UserManager/ts/IUser";
import IRole from "@/modules/UserManager/ts/IRole";

export const getters: GetterTree<any, any> = {

    users: (state: any) => {
        return Array.from(state.users);
    },

    getUserClone: (state: any) => (userId: number) => {
        let user = state.users.find((user: IUser) => {
            return user.id == userId;
        });

        // Return copy of the original object
        return Object.assign({}, user);
    },

    usersByRole: (state: any) => (roleNames: Array<string>, exclude: IUser) => {
        return state.users.filter( (user: IUser) => {

            if (exclude && user.id === exclude.id) return false;
            if (!user.roles) return false;

            let found = user.roles.find ((role: IRole) => {
                return roleNames.includes(role.name)
            });
            return !!found;
        });
    }
};
